// 修正候補ツールチップ
//
// 設計方針:
// - グローバルに 1つだけ存在する（複数 textarea で共有）
// - 赤波線をクリックされたらその位置に表示
// - 「理由」「修正候補（あれば）」「無視する」ボタンを表示
// - 外側クリック / ESC / 新しいツールチップ表示で自動的に閉じる
// - 非エンジニア向け: シンプルな言葉・大きめのタップ領域・アニメーションなし

let tooltipEl = null
let currentContext = null // { textarea, msg, range }
let outsideClickHandler = null
let keydownHandler = null

function ensureTooltip() {
  if (tooltipEl) return tooltipEl
  tooltipEl = document.createElement('div')
  tooltipEl.className = 'proofread-tooltip'
  tooltipEl.setAttribute('role', 'dialog')
  tooltipEl.style.display = 'none'
  // ツールチップ内ボタンをタップした際に textarea の blur が発生すると
  // モバイルではソフトキーボードが閉じてしまう。要素全体で mousedown の
  // デフォルト動作を止めれば、click は従来どおり発火しつつ focus は
  // textarea に残せる。
  tooltipEl.addEventListener('mousedown', (e) => {
    e.preventDefault()
  })
  document.body.appendChild(tooltipEl)
  return tooltipEl
}

function buildHtml(msg) {
  const reason = msg.message || '指摘内容が取得できませんでした。'
  const fixText =
    msg.fix && typeof msg.fix.text === 'string' ? msg.fix.text : null

  let suggestionHtml = ''
  if (fixText !== null) {
    suggestionHtml = `
      <div class="proofread-tooltip__suggestion-label">こう直すのはどう？</div>
      <button type="button" class="proofread-tooltip__apply">
        <span class="proofread-tooltip__apply-text">${escapeHtml(
          fixText || '（削除）'
        )}</span>
        <span class="proofread-tooltip__apply-hint">クリックで置き換え</span>
      </button>
    `
  }

  return `
    <div class="proofread-tooltip__reason">${escapeHtml(reason)}</div>
    ${suggestionHtml}
    <div class="proofread-tooltip__actions">
      <button type="button" class="proofread-tooltip__ignore">このままにする</button>
    </div>
  `
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function position(anchor) {
  const tip = tooltipEl
  const rect = anchor.getBoundingClientRect()
  const tipRect = tip.getBoundingClientRect()
  const margin = 8

  const top = rect.bottom + window.scrollY + margin
  let left = rect.left + window.scrollX

  // 画面右端はみ出し補正
  const vw = document.documentElement.clientWidth
  if (left + tipRect.width > vw - margin) {
    left = Math.max(margin, vw - tipRect.width - margin)
  }

  tip.style.top = `${top}px`
  tip.style.left = `${left}px`
}

function attachGlobalListeners() {
  outsideClickHandler = (e) => {
    if (!tooltipEl) return
    if (tooltipEl.contains(e.target)) return
    // anchor クリックは上位 overlay で stopPropagation してるので基本届かない
    hideTooltip()
  }
  keydownHandler = (e) => {
    if (e.key === 'Escape') hideTooltip()
  }
  document.addEventListener('mousedown', outsideClickHandler, true)
  document.addEventListener('keydown', keydownHandler, true)
}

function detachGlobalListeners() {
  if (outsideClickHandler) {
    document.removeEventListener('mousedown', outsideClickHandler, true)
    outsideClickHandler = null
  }
  if (keydownHandler) {
    document.removeEventListener('keydown', keydownHandler, true)
    keydownHandler = null
  }
}

function applyFix() {
  if (!currentContext) return
  const { textarea, msg, _range } = currentContext
  if (!msg.fix || !Array.isArray(msg.fix.range)) return
  const [start, end] = msg.fix.range
  const newText =
    textarea.value.slice(0, start) +
    (msg.fix.text || '') +
    textarea.value.slice(end)
  textarea.value = newText
  // Vue の v-model に反映させるため input イベントを手動発火
  textarea.dispatchEvent(new Event('input', { bubbles: true }))
  hideTooltip()
  textarea.focus()
}

/**
 * ツールチップを表示する。
 * @param {object} msg  lint message
 * @param {HTMLElement} anchor  クリックされた .proofread-mark 要素
 * @param {HTMLTextAreaElement} textarea
 * @param {object} range  { start, end, msg }
 * @param {object} [callbacks]
 * @param {Function} [callbacks.onDismiss]  「このままにする」押下時のコールバック
 */
export function showTooltip(msg, anchor, textarea, range, callbacks) {
  // 既に表示中なら先にクリーンアップ（リスナーリーク防止）
  hideTooltip()

  const tip = ensureTooltip()
  currentContext = { textarea, msg, range }

  tip.innerHTML = buildHtml(msg)
  tip.style.display = 'block'
  position(anchor)

  // ボタン配線
  const applyBtn = tip.querySelector('.proofread-tooltip__apply')
  if (applyBtn) {
    applyBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      applyFix()
    })
  }
  const ignoreBtn = tip.querySelector('.proofread-tooltip__ignore')
  if (ignoreBtn) {
    ignoreBtn.addEventListener('click', (e) => {
      e.stopPropagation()
      if (callbacks && typeof callbacks.onDismiss === 'function') {
        callbacks.onDismiss(msg, range)
      }
      hideTooltip()
    })
  }

  if (!outsideClickHandler) attachGlobalListeners()
}

export function hideTooltip() {
  if (tooltipEl) {
    tooltipEl.style.display = 'none'
    tooltipEl.innerHTML = ''
  }
  currentContext = null
  detachGlobalListeners()
}
